import { EXPAND_ADDRESS, FAST_COLLAPSE_ADDRESS, SLOW_COLLAPSE_ADDRESS, ADDRESS_EXPANDED, ADDRESS_COLLAPSED, ADDRESS_COLLAPSING } from './CollapsibleAddressFieldsConstants';

export default (state = {
    showAddress: ADDRESS_COLLAPSED
}, action) => {
    switch (action.type) {
        case EXPAND_ADDRESS:
            return Object.assign({}, state, {
                showAddress: ADDRESS_EXPANDED
            });
        case FAST_COLLAPSE_ADDRESS:
            return Object.assign({}, state, {
                showAddress: ADDRESS_COLLAPSED
            });
        case SLOW_COLLAPSE_ADDRESS:
            return Object.assign({}, state, {
                showAddress: ADDRESS_COLLAPSING
            });
        default:
            return state;
    }
};
